import styled from "styled-components";
import {
  orangeColor,
  orangeLightColor,
  progressTitleColor,
} from "../../constants/colors";

const ProgressBlock = styled.div`
  display: flex;
  //align-items: center;
  justify-content: space-between;
  flex-grow: 1;
  height: 30px;
`;

ProgressBlock.Round = styled.div`
  width: 30px;
  height: 30px;

  background: ${(props) => (props.active ? orangeColor : orangeLightColor)};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  p {
    font-size: 16px;
    line-height: 17.6px;
    font-weight: 700;
    color: ${orangeColor};
  }
`;
ProgressBlock.Item = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
`;
ProgressBlock.Line = styled.div`
  flex-grow: 1;
  height: 4px;
  background: ${orangeLightColor};
  position: relative;
`;
ProgressBlock.Line.Title = styled.div`
  position: absolute;
  width: 100%;
  display: flex;
  justify-content: center;
  top: -50px;
  left: 0;
  p {
    color: ${progressTitleColor};
    font-size: 14px;
    line-height: 15px;
    font-weight: 500;
    white-space: nowrap;
  }
`;
ProgressBlock.Line.Load = styled.div`
  width: ${(props) => props.width}%;
  position: absolute;
  left: 0;
  top: 0;
  background: ${(props) => (props.active ? orangeColor : orangeLightColor)};
  height: 100%;
  border-radius: 0 5px 5px 0;
  transition: 0.3s ease-in-out;
`;

export { ProgressBlock };
